import get from 'lodash/get';

import { rootStore } from '../store';
import { isDebugI18nEnabled } from './debug';

export const MODAL_TRANSLATION_KEY = 'useTranslationKey';

function replaceTranslationKey(value: string | string[], translationKey: string): string | string[] {
	if (Array.isArray(value)) {
		const indexToReplace = value.indexOf(MODAL_TRANSLATION_KEY);

		if (indexToReplace >= 0) {
			const result = [...value];
			result[indexToReplace] = translationKey;
			return result;
		}
	}

	if (typeof value === 'string') {
		return value.replace(MODAL_TRANSLATION_KEY, translationKey);
	}

	return value;
}

export default function translate(key: string | string[]): string {
	const [_, currentModelValue] = rootStore.currentModel.get();
	const translationKey = currentModelValue.vehicleConfiguration?.familyName;
	const replacedKey = translationKey ? replaceTranslationKey(key, translationKey) : key;
	const notFoundKey = typeof replacedKey === 'string' ? `$${replacedKey}$` : `$${replacedKey.join('.')}$`;

	if (isDebugI18nEnabled()) {
		return notFoundKey;
	}

	return get(rootStore.translations.get(), replacedKey, '');
}
